import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          热播排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          本周影迷最爱看的电影，实时热度排名一览
        </p>
        <div className="rounded-lg border border-background-300/40 bg-background-100/60 overflow-hidden">
          <div className="divide-y divide-background-300/30">
            {rankingItems.map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 transition-colors duration-150 hover:bg-background-50/50"
              >
                <div
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center shrink-0 text-sm font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'bg-background-200 text-foreground-400'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-800">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-400">{item.category}</span>
                  </div>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <span className="text-xs font-medium text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {item.hot}
                  </span>
                  <span className="text-sm font-bold text-foreground-700 flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    {item.score}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}